var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPitstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0404 11.3927V4.09444L11.3637 0.445312L7.68691 4.09444V6.52718H0.333374V23.5564H22.394V11.3927H15.0404ZM5.23573 21.1237H2.78455V18.6909H5.23573V21.1237ZM5.23573 16.2582H2.78455V13.8254H5.23573V16.2582ZM5.23573 11.3927H2.78455V8.95993H5.23573V11.3927ZM12.5893 21.1237H10.1381V18.6909H12.5893V21.1237ZM12.5893 16.2582H10.1381V13.8254H12.5893V16.2582ZM12.5893 11.3927H10.1381V8.95993H12.5893V11.3927ZM12.5893 6.52718H10.1381V4.09444H12.5893V6.52718ZM19.9428 21.1237H17.4916V18.6909H19.9428V21.1237ZM19.9428 16.2582H17.4916V13.8254H19.9428V16.2582Z",
    fill: "#C3CBD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPitstop);
export default __webpack_public_path__ + "static/media/icon-pitstop.026ffb6c68d2b468d45dfa1003c167cd.svg";
export { ForwardRef as ReactComponent };